var address = require('./')();

var url = require('url');

module.exports = function prepareUrls() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var protocol = option.protocol,
      host = option.host,
      port = option.port;

  var formatUrl = function formatUrl(hostname) {
    return url.format({
      protocol: protocol,
      hostname: hostname,
      port: port,
      pathname: '/'
    });
  };

  var isUnspecifiedHost = host === '0.0.0.0' || host === '::';
  var prettyHost = isUnspecifiedHost ? 'localhost' : host;
  var localUrl = formatUrl(prettyHost);
  var lanUrl = formatUrl(address);
  return {
    ip: address,
    localUrl: localUrl,
    lanUrl: lanUrl
  };
};